<template>
    <div class="modal-content">
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <header class="modal-card-head has-background-white">
                <h3 class="modal-card-title has-text-centered">
                    Conciliar
                </h3>
                <button
                    class="delete"
                    aria-label="Cerrar Modal"
                    @click="$emit('close')"
                ></button>
            </header>
            <section class="modal-card-body has-background-white has-text-left">
                <div>
                    <div class="columns is-mobile is-multiline is-vcentered">
                        <div
                            class="column column-reconciliation is-5-mobile is-3-tablet has-text-grey"
                        >
                            Descripción
                        </div>
                        <div
                            class="column column-reconciliation is-12-mobile is-6-tablet is-uppercase has-text-weight-semibold text-align-left"
                        >
                            {{ modalData.description }}
                        </div>
                    </div>
                    <div class="columns is-mobile is-multiline is-vcentered">
                        <div
                            class="column column-reconciliation is-5-mobile is-3-tablet has-text-grey"
                        >
                            Monto
                        </div>
                        <div
                            class="column column-reconciliation movement-amount is-5-mobile is-2-tablet has-text-weight-semibold"
                        >
                            <span v-if="modalData.amount < 0">
                                {{ (modalData.amount * -1) | toMoney }}
                            </span>
                            <span v-else>
                                {{ modalData.amount | toMoney }}
                            </span>
                        </div>
                        <div
                            class="column column-reconciliation is-5-mobile is-2-tablet has-text-grey"
                        >
                            Banco
                        </div>
                        <div
                            class="column column-reconciliation is-6-mobile is-3-tablet has-text-weight-semibold"
                        >
                            {{ modalData.owner_account_name }}
                        </div>
                        <div
                            class="column column-reconciliation is-3-mobile is-2-tablet has-text-right"
                        >
                            <b-tag :type="trendingType.style" rounded>
                                {{ trendingType.name }}
                            </b-tag>
                        </div>
                    </div>
                    <div class="columns is-mobile is-multiline is-vcentered">
                        <div
                            class="column column-reconciliation is-5-mobile is-3-tablet has-text-grey"
                        >
                            Conciliado
                        </div>
                        <div
                            class="column column-reconciliation movement-amount is-5-mobile is-2-tablet has-text-weight-semibold has-text-secondary"
                        >
                            <span>
                                {{ modalData.reconciliation_amount | toMoney }}
                            </span>
                        </div>
                        <div
                            class="column column-reconciliation is-5-mobile is-2-tablet has-text-grey"
                        >
                            Por conciliar
                        </div>
                        <div
                            class="column column-reconciliation movement-amount is-5-mobile is-2-tablet has-text-weight-semibold has-text-secondary"
                        >
                            <span>
                                {{
                                    modalData.pending_reconciliation_amount
                                        | toMoney
                                }}
                            </span>
                        </div>
                    </div>
                    <div
                        class="columns is-mobile is-multiline is-vcentered mt-4 py-4 bt"
                    >
                        <div
                            class="column column-reconciliation is-12-mobile is-6-tablet has-text-weight-semibold"
                        >
                            Busca la obligación para este movimiento
                        </div>
                    </div>

                    <div class="columns is-mobile is-multiline is-vcentered">
                        <div
                            class="column column-reconciliation is-5-mobile is-2-tablet"
                        >
                            <b-datepicker
                                placeholder="01-12-2021"
                                v-model="startDate"
                                :mobile-native="false"
                                :date-formatter="
                                    (date) => moment(date).format('DD-MM-YYYY')
                                "
                            >
                            </b-datepicker>
                        </div>
                        <div
                            class="column column-reconciliation is-1-mobile is-1-tablet"
                        >
                            <img class="arrowRightIcon" :src="arrowRightIcon" />
                        </div>
                        <div
                            class="column column-reconciliation is-5-mobile is-2-tablet"
                        >
                            <b-datepicker
                                placeholder="31-12-2021"
                                v-model="endDate"
                                :mobile-native="false"
                                :date-formatter="
                                    (date) => moment(date).format('DD-MM-YYYY')
                                "
                            >
                            </b-datepicker>
                        </div>
                        <div
                            class="column column-reconciliation is-11-mobile is-5-tablet"
                        >
                            <b-input
                                placeholder="Búsqueda por contraparte o RUT"
                                v-model="search"
                            ></b-input>
                        </div>
                        <div
                            class="column column-reconciliation is-11-mobile is-2-tablet"
                        >
                            <b-button
                                type="is-secondary"
                                @click="handleSubmit(getCoincidences())"
                                :disabled="loading"
                                role="button"
                                >Buscar coincidencias</b-button
                            >
                        </div>
                    </div>
                    <div class="columns is-mobile is-multiline is-vcentered">
                        <div
                            class="column column-reconciliation is-5-mobile is-2-tablet"
                        >
                            <b-input
                                placeholder="Nº Documento"
                                v-model="document_number"
                            ></b-input>
                        </div>
                        <div
                            class="column column-reconciliation is-6-mobile is-3-tablet"
                        >
                            <b-input
                                placeholder="Monto"
                                v-model="amount"
                                v-money="amount !== null ? moneyConfig : null"
                                money="false"
                                rules="required|positive-money|max:13"
                            ></b-input>
                        </div>
                        <div
                            class="column column-reconciliation is-11-mobile is-5-tablet"
                        >
                            <b-select
                                placeholder="Tipo de obligación"
                                expanded
                                v-model="obligation_type__id"
                                data-testid="obligationSelect"
                            >
                                <option
                                    v-for="option in obligationTypesListFiltered"
                                    :value="option.id"
                                    :key="option.id"
                                    name="obligation"
                                >
                                    {{ option.name }}
                                </option>
                            </b-select>
                        </div>
                        <div
                            class="column column-reconciliation is-11-mobile is-2-tablet has-text-centered"
                        >
                            <b-button
                                type="is-secondary"
                                class="buttonSearch"
                                role="button"
                                outlined
                                :disabled="loading"
                                @click="handleSubmit(onCleanFilter())"
                                >Limpiar búsqueda</b-button
                            >
                        </div>
                    </div>
                </div>
                <div class="columns is-mobile is-multiline boxObligations mt-6">
                    <div
                        class="main-section tabla-documentos obligations table-reconciliation"
                    >
                        <div class="container-table">
                            <b-table
                                :data="taxDocumentsList"
                                :loading="loading"
                                paginated
                                checkable
                                sticky-checkbox
                                :checked-rows.sync="checkedRows"
                                :custom-is-checked="(a, b) => a.id === b.id"
                                sticky
                                sticky-header
                                ref="table"
                                backend-pagination
                                :total="numberRegisters"
                                :per-page="perPage"
                                @page-change="onPageChange"
                                :current-page="page"
                                aria-next-label="Página Siguiente"
                                aria-previous-label="Página Anterior"
                                detailed
                                :show-detail-icon="false"
                                aria-page-label="Página"
                                aria-current-label="Página Actual"
                                backend-sorting
                                :default-sort-direction="defaultSortOrder"
                                :default-sort="[sortField, sortOrder]"
                                @sort="onSort"
                                @update-table="searchCoincidences"
                            >
                                <b-table-column
                                    field="document_number"
                                    label="Nº Doc"
                                    numeric
                                    centered
                                    cellClass="document-number has-text-weight-bold is-size-6 is-family-monospace"
                                    width="120px"
                                    v-slot="props"
                                >
                                    <span
                                        v-if="
                                            !props.row.obligation_type
                                                .has_auto_doc_number
                                        "
                                    >
                                        {{ props.row.document_number }}
                                    </span>
                                </b-table-column>
                                <b-table-column
                                    field="emitted_at"
                                    label="Fecha emisión"
                                    centered
                                    cellClass="document-expiration"
                                    width="120px"
                                    v-slot="props"
                                >
                                    <div
                                        class="is-flex is-justify-content-center family-primary"
                                    >
                                        <span>
                                            {{ props.row.emitted_at }}
                                        </span>
                                    </div>
                                </b-table-column>
                                <b-table-column
                                    field="obligation_type.name"
                                    label="Obligaciones"
                                    cellClass="obligation-type has-text-left"
                                    width="120px"
                                    v-slot="props"
                                >
                                    <div
                                        class="is-flex is-justify-content-left"
                                    >
                                        <img
                                            alt="obligacion proveniente desde el SII"
                                            style="max-width:20px"
                                            :src="siiLogo"
                                            v-if="
                                                firstSyncCompleted &&
                                                    props.row.obligation_type
                                                        .sii_code !== null
                                            "
                                        />
                                        <span class="ml-1 has-text-left">{{
                                            props.row.obligation_type.name
                                        }}</span>
                                    </div>
                                </b-table-column>
                                <b-table-column
                                    field="counterpart.name"
                                    label="Contraparte"
                                    cellClass="document-name has-text-weight-bold"
                                    width="280px"
                                    v-slot="props"
                                >
                                    <div class="counterpart-name">
                                        <span>
                                            {{ props.row.counterpart.name }}
                                        </span>
                                        <span v-if="isRendition(props.row)"
                                            >- {{ props.row.description }}</span
                                        >
                                    </div>
                                    <div class="counterpart-rut">
                                        {{ props.row.counterpart.rut }}
                                    </div>
                                </b-table-column>
                                <b-table-column
                                    field="amount"
                                    label="Monto"
                                    numeric
                                    cellClass="document-amount has-text-right"
                                    width="110px"
                                    v-slot="props"
                                >
                                    <span
                                        class="is-size-6 has-text-weight-semibold is-family-monospace"
                                    >
                                        {{ getAmount(props.row) | toMoney }}
                                    </span>
                                    <br />
                                    <span
                                        v-if="
                                            props.row.reconciliation_amount &&
                                                props.row
                                                    .pending_reconciliation_amount !==
                                                    0
                                        "
                                        class="is-size-7"
                                        >Total:
                                    </span>
                                    <span
                                        v-if="
                                            props.row.reconciliation_amount &&
                                                props.row
                                                    .pending_reconciliation_amount !==
                                                    0
                                        "
                                        class="is-size-7 is-family-monospace"
                                    >
                                        {{
                                            getAmount(props.row, true) | toMoney
                                        }}
                                    </span>
                                    <br />
                                </b-table-column>
                                <template #empty>
                                    <div class="has-text-centered">
                                        No hay obligaciones para mostrar
                                    </div>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>
            </section>
            <footer
                class="modal-card-foot bt-none has-background-white is-justify-content-flex-end"
            >
                <button
                    class="button"
                    @click="$emit('close')"
                    aria-label="Cerrar Modal"
                    role="button"
                >
                    Volver
                </button>
                <button
                    class="button is-primary"
                    aria-label="Modificar Recurrencia"
                    :disabled="loading || (!checkedRows.length && !toUpdate)"
                    role="button"
                    @click="handleSubmit(saveMatchObligations(modalData))"
                >
                    <span v-if="toUpdate">
                        Actualizar cambios
                    </span>
                    <span v-else>
                        Confirmar
                    </span>
                </button>
            </footer>
        </ValidationObserver>
    </div>
</template>

<script>
import { bankMovementsUpdate } from "@/api/financialEntity";
import { getAll } from "@/api/taxDocument";
import arrowRight from "@/assets/images/arrow_right.svg";
import siiMini from "@/assets/images/sii-mini.svg";
import { configMoney, Money, parseToMoney } from "@/utils/currency";
import { consoleHandlerError, notificate } from "@/utils/message";
import SegmentAnalytics from "@/utils/segmentAnalytics";
import moment from "moment";
import { ValidationObserver } from "vee-validate";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
    name: "BankReconciliation",
    components: {
        ValidationObserver,
    },
    data() {
        return {
            arrowRightIcon: arrowRight,
            loading: false,
            startDate: null,
            endDate: null,
            search: null,
            document_number: null,
            amount: null,
            obligation_type__id: null,
            page: 1,
            perPage: 16,
            numberRegisters: 0,
            siiLogo: siiMini,
            sortField: "",
            sortOrder: "desc",
            defaultSortOrder: "asc",
            taxDocumentsList: [],
            taxDocumentsRelatedList: [],
            checkedRows: [],
            toUpdate: false,
            numRelateObligations: 0,
            moneyConfig: configMoney,
        };
    },
    methods: {
        ...mapActions("taxDocument", [
            "getObligationTypesList",
            "getAllTaxDocuments",
            "getTotalPay",
            "getTotalCollect",
        ]),
        ...mapActions("graphCashFlow", ["getForecastFlowCash"]),
        ...mapActions("financialEntity", ["getBankMovements"]),
        ...mapMutations("financialEntity", ["SET_DETAILS_OPEN_LIST"]),
        moment(date) {
            moment.locale("es");
            return moment(date);
        },
        onPageChange(page) {
            this.page = page;
            this.searchCoincidences();
        },
        onSort(field, order) {
            this.sortField = field;
            this.sortOrder = order;
            this.searchCoincidences();
        },
        onCleanFilter() {
            this.startDate = null;
            this.endDate = null;
            this.search = null;
            this.document_number = null;
            this.amount = null;
            this.obligation_type__id = null;
            this.page = 1;
            this.searchCoincidences();
        },
        selectObligationTypesList: function() {
            this.getObligationTypesList().catch((error) => {
                consoleHandlerError({ error, empty: true });
            });
        },
        getCoincidences() {
            this.page = 1;
            this.searchCoincidences();
        },
        getRelatedObligations() {
            const movement = this.modalData;
            movement.tax_documents.forEach((element) => {
                let { emitted_at, ...taxDocument } = element;
                element = Object.assign({}, taxDocument, {
                    emitted_at: moment(emitted_at).format("DD-MM-YYYY"),
                });

                this.taxDocumentsRelatedList.push(element);
                if (
                    movement &&
                    element.account_movements &&
                    element.account_movements.includes(movement.id)
                ) {
                    this.checkedRows.push(element);
                }
            });
            this.toUpdate = this.checkedRows.length > 0;
            this.perPage += this.checkedRows.length;
        },
        searchCoincidences() {
            const movement = this.modalData;
            this.loading = true;
            const backendFilters = {
                page: this.page,
                flag: "bank_reconciliation",
                document_type: this.documentType,
                ...(this.startDate && {
                    start_date: moment(this.startDate).format("YYYY-MM-DD"),
                }),
                ...(this.endDate && {
                    end_date: moment(this.endDate).format("YYYY-MM-DD"),
                }),
                ...(this.search && {
                    search: this.search,
                }),
                ...(this.document_number && {
                    document_number: this.document_number,
                }),
                ...(this.amount && {
                    amount: this.amount.replace("$ ", "").replaceAll(".", ""),
                }),
                ...(this.obligation_type__id && {
                    obligation_type__id: this.obligation_type__id,
                }),
            };
            const queryParams = `account_movements__id!=${movement.id}`;

            this.taxDocumentsList = [];
            getAll({ params: backendFilters }, queryParams)
                .then((response) => {
                    const data = response.data;
                    data.results.forEach((element) => {
                        let { emitted_at, ...taxDocument } = element;
                        element = Object.assign({}, taxDocument, {
                            emitted_at: moment(emitted_at).format("DD-MM-YYYY"),
                        });
                        this.taxDocumentsList.push(element);
                    });
                    this.numberRegisters = response.data.count;
                    this.taxDocumentsRelatedList.forEach((element) => {
                        if (!this.taxDocumentsList.includes(element)) {
                            this.taxDocumentsList.unshift(element);
                        }
                    });
                })
                .catch((error) => {
                    consoleHandlerError({ error, empty: true });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        isRendition(item) {
            return item.obligation_type.name === "Rendición";
        },
        saveMatchObligations(movement) {
            this.loading = true;
            const field = {
                tax_documents: this.checkedRows.map((item) => item.id),
            };
            bankMovementsUpdate({
                id: movement.id,
                field: field,
            })
                .then(() => {
                    new SegmentAnalytics().trackUpdateMovement(movement);
                    notificate(
                        `<strong>MOVIMIENTO BANCARIO</strong><br>
                        ha sido actualizado exitosamente`,
                        "is-success is-light"
                    );
                    this.getTotalPay();
                    this.getTotalCollect();
                    this.getAllTaxDocuments().catch((error) => {
                        consoleHandlerError({ error, empty: true });
                    });
                    this.getForecastFlowCash().catch((error) => {
                        consoleHandlerError({ error });
                    });
                    this.SET_DETAILS_OPEN_LIST([]);
                    this.getBankMovements().catch((error) => {
                        consoleHandlerError({ error, empty: true });
                    });
                    this.$emit("close");
                })
                .catch((error) => {
                    consoleHandlerError({ error });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getAmount(itemTaxDocument, isTotal = false) {
            if (isTotal) {
                return (
                    itemTaxDocument.pending_reconciliation_amount +
                    itemTaxDocument.reconciliation_amount
                );
            }
            if (
                itemTaxDocument.obligation_type.name ==
                    "Boleta de Honorarios" &&
                itemTaxDocument.pending_reconciliation_amount == 0
            ) {
                return (
                    itemTaxDocument.reconciliation_amount ||
                    itemTaxDocument.amount
                );
            } else if (
                itemTaxDocument.obligation_type.name ==
                    "Boleta de Honorarios" &&
                itemTaxDocument.pending_reconciliation_amount != 0
            ) {
                return itemTaxDocument.pending_reconciliation_amount;
            }
            return (
                itemTaxDocument.pending_reconciliation_amount ||
                itemTaxDocument.amount
            );
        },
    },
    filters: {
        toMoney: (value) => {
            return parseToMoney(value);
        },
    },
    computed: {
        ...mapState("userAuth", ["company", "hasSIIAutomation"]),
        ...mapState("financialEntity", ["modalData"]),
        ...mapState("userAuth", ["user"]),
        ...mapState("taxDocument", ["obligationTypesList"]),
        obligationTypesListFiltered: function() {
            let obligationsList = this.obligationTypesList.filter(
                (item) => item.name !== "Remuneraciones"
            );
            return obligationsList;
        },
        trendingType: function() {
            if (this.modalData.amount > 0) {
                return {
                    name: "Abono",
                    style: "bankMovementsIncome has-text-income is-white",
                };
            } else {
                return {
                    name: "Cargo",
                    style: "bankMovementsOutcome has-text-outcome is-white",
                };
            }
        },
        documentType: function() {
            return this.modalData.amount > 0 ? "C" : "P";
        },
        firstSyncCompleted: function() {
            return this.company.first_sync_completed;
        },
    },
    async mounted() {
        this.selectObligationTypesList();
        await this.getRelatedObligations();
        await this.searchCoincidences();
    },
    directives: { money: Money },
};
</script>
